import { dispatchAction } from '@ardoq/rxbeach';
import * as topBarActions from './actions';
import { TrackingEvent } from 'tracking/trackPayload';
import { trackingData } from 'tracking/trackingData';

const closeSidebar = (trackingEvent?: TrackingEvent) =>
  dispatchAction(
    topBarActions.closeSidebar({
      [trackingData]: trackingEvent,
    })
  );

const openSidebar = (trackingEvent?: TrackingEvent) =>
  dispatchAction(
    topBarActions.openSidebar({
      [trackingData]: trackingEvent,
    })
  );

const hoverSidebar = (trackingEvent?: TrackingEvent) =>
  dispatchAction(
    topBarActions.hoverSidebar({
      [trackingData]: trackingEvent,
    })
  );

export type NavigationTopBarCommands = {
  closeSidebar: (trackingEvent?: TrackingEvent) => void;
  openSidebar: (trackingEvent?: TrackingEvent) => void;
  hoverSidebar: (trackingEvent?: TrackingEvent) => void;
};

export const navigationTopBarCommands: NavigationTopBarCommands = {
  closeSidebar,
  openSidebar,
  hoverSidebar,
};
